export const initialCache = {
  userSettings: {
    __typename: 'UserSettings',
    language: 'en', // default language
    theme: 'light', // default theme
  },
};
